import { Card, Typography } from "antd";
import React from "react";
const { Title, Text } = Typography;

const Cards = ({ item }) => {
  return (
    <Card
      bordered
      style={{
        borderColor: "#7D7C7C",
        padding: "7px",
        height: "120px",
        borderRadius: "6px",
        cursor: "pointer",
        background: "#fff",
      }}
      bodyStyle={{ padding: 8 }}
    >
      <div className="flex gap-1 items-center">
        <Text className="font-semibold text-[14px] text-center w-full uppercase text-gray-600">
          {item?.label}
        </Text>
      </div>

      <div className="text-[24px] font-bold w-full text-center">
        {item?.value}
      </div>
      <div className="flex justify-center gap-1">
        {item?.child?.[0] && (
          <span className="text-[11px] font-semibold px-2 py-[3px] border border-blue-200 bg-blue-50 rounded-md text-blue-700">
            {item?.child?.[0]?.label}: {item?.child?.[0]?.value}
          </span>
        )}
        {item?.child?.[1] && (
          <span className="text-[11px] font-semibold px-2 py-[3px] border border-green-200 bg-green-50 rounded-md text-green-700">
            {item?.child?.[1]?.label}: {item?.child?.[1]?.value}
          </span>
        )}
      </div>
    </Card>
  );
};

export default Cards;
